// extracted by mini-css-extract-plugin
export var article = "blog-post-module--article--dQKQ+";
export var articleNavigation = "blog-post-module--articleNavigation--204p8";
export var body = "blog-post-module--body--fmI8r";
export var container = "blog-post-module--container--I0jV6";
export var meta = "blog-post-module--meta--XwIyg";